import { useTranslation as useTranslate } from 'react-i18next';

export type Translation = (path: string) => string;

export const LANGUAGE_KEY = 'lapzo_language';

export const selectItemsLanguages = [
  {
    value: '🇲🇽 Español',
    key: '0',
  },
  {
    value: '🇺🇸 Inglés',
    key: '1',
  },
];

export const languagesKeys = {
  '0': 'es',
  '1': 'en',
};

export type TFunction = (key: string, options?: Record<string, any>) => string;

export const useTranslation = () => {
  const { t } = useTranslate();
  return t;
};
